import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material';
import { CoreTypography } from '@youscience/core';

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  // TODO add colors to library
  backgroundColor: '#F9F9F9',
  overflow: 'hidden',
  margin: '0 !important',

  '&:before': {
    height: 0,
  },
}));

export const StyledAccordionTitle = styled(CoreTypography)(({ theme }) => ({
  '&:before': {
    height: '1px',
    backgroundColor: theme.palette.grey[300],
    content: '""',
    position: 'absolute',
    bottom: '0.5rem',
    width: '100%',
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  padding: 0,
  minHeight: '64px',
  position: 'relative',

  '.MuiAccordionSummary-content': {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
    margin: '0.5rem 0',
  },

  '.Mui-expanded': {
    margin: '0.5rem 0 !important',
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '2rem',
  padding: '1rem 0 1.5rem 0',

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));
